const API_URL = process.env.REACT_APP_API_URL;
const getBaseUrl = () => API_URL;

const queryString = (params: { [key: string]: string }) => {
  if (Object.keys(params).length === 0) return '';
  let queryStr =
    '?' +
    Object.keys(params)
      .reduce(function (acc: string[], k: string) {
        acc.push(k + '=' + encodeURIComponent(params[k] as string));
        return acc;
      }, [])
      .join('&');
  return queryStr;
};

export const get = (
  url: string,
  queryParams = {},
  showToast?: ShowToastType
) => {
  return fetch(`${getBaseUrl()}/${url}${queryString(queryParams)}`, {
    method: 'GET',
  })
    .then((response) => {
      if (response.status >= 200 && response.status < 400) {
        return response.json();
      }
      showApiErrorToast(response, showToast);
      return false;
    })
    .catch(() => {
      alert(
        'Something went wrong. Please contact support or try again in sometime.'
      );
      return false;
    });
};
export const getFile = (
  url: string,
  queryParams = {},
  showToast?: ShowToastType
) => {
  return fetch(`${getBaseUrl()}/${url}${queryString(queryParams)}`, {
    method: 'GET',
    headers: {},
  }).then((response: any) => {
    if (response.status >= 200 && response.status < 400) {
      return response;
    }
    showApiErrorToast(response, showToast);
    return false;
  });
};
export const post = (
  url: string,
  bodyObject: object,
  showToast?: ShowToastType
) => {
  return fetch(`${getBaseUrl()}/${url}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bodyObject),
  })
    .then((response) => {
      if (response.status >= 200 && response.status < 400) {
        if (parseInt(response.headers.get('content-length')!) > 0) {
          return response.json();
        }
        return true;
      }
      showApiErrorToast(response, showToast);
      return false;
    })
    .catch(() => {
      alert(
        'Something went wrong. Please contact support or try again in sometime.'
      );
      return false;
    });
};
export const postFile = (
  url: string,
  bodyObject: any,
  showToast?: ShowToastType
) => {
  return fetch(`${getBaseUrl()}/${url}`, {
    method: 'POST',
    body: bodyObject,
  }).then((response: any) => {
    if (response.status >= 200 && response.status < 400) {
      return response;
    }
    showApiErrorToast(response, showToast);
    return false;
  });
};
export const postWithJsonResponse = (
  url: string,
  bodyObject: object,
  showToast?: ShowToastType
) => {
  return fetch(`${getBaseUrl()}/${url}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bodyObject),
  })
    .then((response) => {
      if (response.status >= 200 && response.status < 400) {
        return response.json();
      }
      showApiErrorToast(response, showToast);
      return false;
    })
    .catch(() => {
      alert(
        'Something went wrong. Please contact support or try again in sometime.'
      );
      return false;
    });
};
export const put = (
  url: string,
  bodyObject: object,
  showToast?: ShowToastType
) => {
  return fetch(`${getBaseUrl()}/${url}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bodyObject),
  })
    .then((response) => {
      if (response.status >= 200 && response.status < 400) {
        if (parseInt(response.headers.get('content-length')!) > 0) {
          return response.json();
        }
        return true;
      }
      showApiErrorToast(response, showToast);
      return false;
    })
    .catch(() => {
      alert(
        'Something went wrong. Please contact support or try again in sometime.'
      );
      return false;
    });
};

export const deleteApi = (
  url: string,
  bodyObject = {},
  showToast?: ShowToastType
) => {
  return fetch(`${getBaseUrl()}/${url}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bodyObject),
  })
    .then((response) => {
      if (response.status >= 200 && response.status < 400) {
        return true;
      }
      showApiErrorToast(response, showToast);
      return false;
    })
    .catch(() => {
      alert(
        'Something went wrong. Please contact support or try again in sometime.'
      );
      return false;
    });
};
export type ShowToastType = (showToast: any) => void;
export type ShowLoaderType = (showLoader: any) => void;
export const showApiErrorToast = (response: any, showToast?: ShowToastType) => {
  if (response.status === 418) {
    response.json().then((errorResopnse: any) => {
      errorResopnse &&
        showToast &&
        showToast({
          theme: 'error',
          message: errorResopnse.message,
          title: 'Error',
          autoClose: false,
        });
    });
  } else {
    showToast &&
      showToast({
        theme: 'error',
        message: 'Something went wrong please try again',
        title: 'Error',
        autoClose: true,
      });
  }
};
